import React from 'react';

import {Content, DropDown, Trigger} from '../drop-down';
import {cls} from '../../utils';
import {ChevronDownIcon} from '../svg-icon';
import {Button, ButtonAppearance, ButtonShape, ButtonSize} from '../inputs/button';

import css from './popover-button.module.css';

type Props = {
	popover: React.ReactNode;
	disabled?: boolean;
	className?: string;
	/** класс кнопки, пока выпадашка открыта */
	openClassName?: string;
	popoverClassName?: string;
	checked?: boolean;
	hasChevron?: boolean;
	label?: string;
	error?: string;
	appearance?: ButtonAppearance;
	size?: ButtonSize;
	shape?: ButtonShape;
	/** иконка кнопки; без children кнопка становится квадратной «только с иконкой» */
	icon?: React.ReactNode;
	/** выпадашка с текстом, а не со списком кнопок: шире и с отступами абзаца */
	message?: boolean;
	/** прижать выпадашку к правому краю кнопки */
	align?: 'start' | 'end';
	setRef?: React.RefObject<HTMLButtonElement | HTMLAnchorElement | null>;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'popover'>;

export const PopoverButton: React.FC<Props> = ({
	children,
	label,
	appearance,
	size,
	shape,
	icon,
	popover,
	className,
	openClassName,
	popoverClassName,
	disabled,
	checked,
	hasChevron,
	error,
	setRef,
	message,
	align,
	...props
}) => (
	<DropDown disabled={disabled} className={css.wrapper}>
		{label && <div className={cls(css.label, error && css.labelError)}>{label}</div>}

		<Trigger>
			<Button
				{...(props as React.ComponentProps<typeof Button>)}
				setRef={setRef}
				disabled={disabled}
				className={cls(className, css.button, openClassName)}
				checked={checked}
				appearance={appearance}
				size={size}
				shape={shape}
				icon={icon}
			>
				{children || hasChevron ? (
					<>
						{children}
						{hasChevron && <ChevronDownIcon width={12} height={12} className={css.chevron} />}
					</>
				) : undefined}
			</Button>
		</Trigger>

		{!!error && <div className={css.error}>{error}</div>}

		<Content align={align} className={cls(message ? css.message : css.menu, popoverClassName)}>
			{popover}
		</Content>
	</DropDown>
);
